export enum EWorksWith {
  ADULTS = 'adults',
  TEENAGERS = 'teenagers',
  COUPLES = 'couples',
  GROUP_SETTINGS = 'group sessions',
}

export const worksWithNamesConfig: Record<string, string> = {
  [EWorksWith.ADULTS]: 'Работаю со взрослыми',
  [EWorksWith.TEENAGERS]: 'Работаю с подростками',
  [EWorksWith.COUPLES]: 'Работаю с парами',
  [EWorksWith.GROUP_SETTINGS]: 'Групповые занятия',
};
